import { schema } from "normalizr";

const NoSeriesListSchema = new schema.Entity("noSeriesLists");
const NoSeriesListArraySchema = new schema.Array(NoSeriesListSchema);

export { NoSeriesListSchema, NoSeriesListArraySchema };